import { cn } from '@/lib/utils';

export const Skeleton = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn('animate-shimmer rounded-control bg-muted', className)}
    aria-hidden
    {...props}
  />
);

/** 一覧の読み込み中表示 */
export const SkeletonRows = ({ rows = 5, className }: { rows?: number; className?: string }) => (
  <div className={cn('space-y-2', className)} role="status" aria-label="読み込んでいます">
    {Array.from({ length: rows }, (_, i) => (
      <Skeleton key={i} className="h-row w-full" />
    ))}
  </div>
);
